import { render, staticRenderFns } from "./AsiLocaleAutocompleteInput.vue?vue&type=template&id=03485013&scoped=true"
import script from "./AsiLocaleAutocompleteInput.vue?vue&type=script&lang=ts"
export * from "./AsiLocaleAutocompleteInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03485013",
  null
  
)

export default component.exports